require('./brokerWarrantsAdvancedSellView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKButton } = require('commonsComponents/OKButton');

// @ components
const { BrokerWarrantsHeader } = require('components/broker/brokerProductHeaders/brokerWarrantsHeader/brokerWarrantsHeader');
const {
    BrokerWarrantsAdvancedSellStep1
} = require('components/broker/brokerWarrantsAdvancedSell/brokerWarrantsAdvancedSellStep1/brokerWarrantsAdvancedSellStep1');
const {
    BrokerWarrantsAdvancedSellStep2
} = require('components/broker/brokerWarrantsAdvancedSell/brokerWarrantsAdvancedSellStep2/brokerWarrantsAdvancedSellStep2');
const BrokerWarrantsAdvancesSellStep3 = require('components/broker/brokerWarrantsAdvancedSell/brokerWarrantsAdvancedSellStep3/brokerWarrantsAdvancedSellStep3');
const BrokerWarrantsAdvancedSellSuccess = require('components/broker/brokerWarrantsAdvancedSell/brokerWarrantsAdvancedSellSuccess/brokerWarrantsAdvancedSellSuccess');

// @ actions
const BrokerWarrantsAdvancedSellActions = require('actions/brokerWarrantsAdvancedSell');
const WarrantFileActions = require('actions/brokerGetWarrantFile.js');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const WebappRender = require('components/conditionalRender/webappRender')

// @ constants
const {
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    BROKER_WARRANTS_HELP_URL,
    BROKER_SELL_SCREEN
} = require('constants/index');

// @ helpers
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { getDocumentURL } = require('utilities/stringHelper');

class BrokerWarrantsAdvancedSellView extends React.Component {
    constructor(props) {
        super(props);
        this.buildWizard = this.buildWizard.bind(this);
        this.buildSuccessful = this.buildSuccessful.bind(this);
        this.getWarrantsDetails = this.getWarrantsDetails.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.getCatalogueDetails = this.getCatalogueDetails.bind(this);
    }

    componentDidMount() {
        const { match: { params }, setOrderID } = this.props;
        this.getCatalogueDetails();
        this.getWarrantsDetails();
        setOrderID(params.isin, params.iso);
        this.props.fetchOpenTraderLink();
    }

    componentWillUnmount() {
        this.props.reset();
    }

    getBreadcrumbData(productFile, exchangeId, spcSymbol) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: productFile.get('companyName'),
                url: `/myprofile/broker/productFile/${exchangeId}/${spcSymbol}`
            },
            {
                text: formatText('breadcrumb-brokerStocksBuy'),
                url: ''
            },
            {
                text: formatText('breadcrumb-brokerAdvancedOrder'),
                url: ''
            }
        ];
    }

    getWarrantsDetails() {
        const { getWarrantsDetails, match: { params: { isin, iso } } } = this.props;
        getWarrantsDetails(isin, iso, BROKER_SELL_SCREEN);
    }

    getCatalogueDetails() {
        this.props.getWarrantCatalogueDetails(this.props.match.params.isin);
    }

    buildSuccessful() {
        const { immBrokerWarrantsAdvancedSell, immStocksContract, immProductFile } = this.props;

        return (
            <div className="row no-gutter">
                <BrokerWarrantsAdvancedSellSuccess
                    immProductFile={immProductFile}
                    immBrokerWarrantsAdvancedSell={immBrokerWarrantsAdvancedSell}
                    immStocksContract={immStocksContract}
                />
            </div>
        );
    }

    buildWizard() {
        const {
            immBrokerWarrantsAdvancedSell,
            immStocksContract,
            immProductFile,
            immVariables,
            mifidClauseChanged
        } = this.props;
        const immSteps = immBrokerWarrantsAdvancedSell.get('steps');
        const visibleStep = immBrokerWarrantsAdvancedSell.get('visibleStep');
        const firstStepLoading = immBrokerWarrantsAdvancedSell.getIn([
            'steps',
            FIRST_STEP,
            'loading'
        ]);
        const secondStepLoading = immBrokerWarrantsAdvancedSell.getIn([
            'steps',
            SECOND_STEP,
            'loading'
        ]);
        const thirdStepLoading = immBrokerWarrantsAdvancedSell.getIn([
            'steps',
            THIRD_STEP,
            'loading'
        ]);
        const actions = {
            setVisibleStep: this.props.setVisibleStep,
            setWillCancel: this.props.setWillCancel,
            finish: this.props.finish,
            validateStep: this.props.validateStep,
            cancel: this.handleCancel
        };
        const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
        const headerMenuData = {
            title: formatText('broker-stocksAdvancedSellWizardTitle'),
            linksData: [
                {
                    label: formatText('broker-stocksAdvancedSellWizardFirstLinkLabel'),
                    href: fees_url,
                    hasTooltip: false,
                    target: '_blank'
                },
                {
                    label: formatText('broker-stocksAdvancedSellWizardSecondLinkLabel'),
                    href: BROKER_WARRANTS_HELP_URL,
                    hasTooltip: false,
                    target: '_blank'
                }
            ]
        };

        return (
            <Wizard
                wizardClass={'broker-warrants-advanced-buy__wizard'}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    addLoadingBehaviour={false}
                    isLoading={firstStepLoading}
                >
                    <BrokerWarrantsAdvancedSellStep1 />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton={true}
                    addLoadingBehaviour={false}
                    isLoading={secondStepLoading}
                >
                    <BrokerWarrantsAdvancedSellStep2
                        immBrokerWarrantsAdvancedSell={immBrokerWarrantsAdvancedSell}
                        immStocksContract={immStocksContract}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    immFinalButton="broker-stocksAdvancedSellFinish"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={thirdStepLoading}
                >
                    <BrokerWarrantsAdvancesSellStep3
                        immProductFile={immProductFile}
                        immBrokerWarrantsAdvancedSell={immBrokerWarrantsAdvancedSell}
                        immStocksContract={immStocksContract}
                        handleMifidClauseChanged={mifidClauseChanged}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    handleCancel() {
        this.props.history.push(`/myprofile/broker`);
    }

    render() {
        const { immMyInvestments, immBrokerWarrantsAdvancedSell, immOpenTrader, immProductFile, warrantFile } = this.props;
        const mappingBreadcrumb = this.getBreadcrumbData(immProductFile, this.props.match.params.exchangeId, this.props.match.params.spcSymbol);
        let contractBoxContent;
        if (immBrokerWarrantsAdvancedSell.get('submitSuccessful')) {
            contractBoxContent = this.buildSuccessful();
        } else {
            contractBoxContent = this.buildWizard();
        }

        return (
            <div className="broker-warrants-advanced-buy-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={getFinalTitle('broker-warrantsAdvancedSellViewTitle')}
                    >
                        <OKButton inverse={true} modifier="ghost" to={MYPROFILE_BROKER_EXPLORE_URL}>
                            <FormattedText format="firstUppercase" value="broker-goToAdvancedSearch" />
                        </OKButton>
                        <WebappRender>
                            <OKButton inverse={true} modifier="primary" to={immOpenTrader.get('openTraderLink')}>
                                <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                            </OKButton>
                        </WebappRender>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-warrants-advanced-buy-view__body">
                    <BrokerWarrantsHeader
                        productFile={immProductFile}
                        warrantFile={warrantFile}
                        immMyInvestments={immMyInvestments}
                        handleUpdate={this.getWarrantsDetails}
                        noBottomButtons={true}
                    />
                    <div className="broker-warrants-advanced-buy-view__wizard">
                        {contractBoxContent}
                    </div>
                </section>
            </div>
        );
    }
}

BrokerWarrantsAdvancedSellView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerWarrantsAdvancedSell: PropTypes.object,
    immOpenTrader: PropTypes.object.isRequired,
    immProductFile: PropTypes.object,
    immStocksContract: PropTypes.object,
    immVariables: PropTypes.object.isRequired,
    reset: PropTypes.func,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    validateStep: PropTypes.func,
    finish: PropTypes.func,
    mifidClauseChanged: PropTypes.func,
    match: PropTypes.object,
    getWarrantsDetails: PropTypes.func,
    setOrderID: PropTypes.func,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    immMyInvestments: PropTypes.func.isRequired,
    warrantFile: PropTypes.object,
};

module.exports.constructor = BrokerWarrantsAdvancedSellView;
module.exports.BrokerWarrantsAdvancedSellView = connect(
    state => ({
        immBrokerWarrantsAdvancedSell: state.brokerWarrantsAdvancedSell,
        immOpenTrader: state.brokerOpenTrader,
        immProductFile: state.brokerProductFile,
        immStocksContract: state.brokerStocksContract,
        immMyInvestments: state.brokerMyInvestments,
        immVariables: state.globalVariables,
        warrantFile: state.brokerWarrantsFile,
    }),
    {
        reset: BrokerWarrantsAdvancedSellActions.reset,
        setVisibleStep: BrokerWarrantsAdvancedSellActions.setVisibleStep,
        setWillCancel: BrokerWarrantsAdvancedSellActions.setWillCancel,
        validateStep: BrokerWarrantsAdvancedSellActions.validateStep,
        finish: BrokerWarrantsAdvancedSellActions.finish,
        mifidClauseChanged: BrokerWarrantsAdvancedSellActions.mifidClauseChanged,
        getWarrantCatalogueDetails: WarrantFileActions.getWarrantCatalogueDetails,
        getWarrantsDetails: WarrantFileActions.getWarrantFile,
        setOrderID: BrokerWarrantsAdvancedSellActions.setOrderID,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink
    }
)(withRouter(BrokerWarrantsAdvancedSellView));
